import {Directive, TemplateRef} from "@angular/core";

/**
 * Структурная директива для переопределения шаблона шапки страницы.
 * @publicApi
 */
@Directive({selector: '[dxPageHeader]'})
export class DxPageHeaderDirective {
  constructor(public template: TemplateRef<any>) {}
}
